import actionTypes from '../actions'
const initialState = {
  industryCategories: [],
  searchCriteria: {
    rowsPerPage: 20,
    companyName: '',
    pageNo: 0,
    businessIds: [],
    zipCode: '',
    miles: 0,
    address: null,
    returnLimit: 1,
    startFrom: 1,
    industry: null,
    establishedYearRange: {
      from: 0,
      to: 0,
    },
    sortBy: {
      field: '',
      order: '',
    },
    skip: 0,
  },
  searchList: null,
  showSpinner: false,
  selectedBusiness: null,
  businessCount: 0,
  monitorCompaniesLoaded: false,
  claimedBusinessesLoaded: false,
  claimedBusinesses: [],
  monitoredCompanies: {
    monitorCompanyIds: [],
    companies: [],
  },
  snakBarData: {
    open: false,
    type: 'success',
    message: '',
  },
  businessDialogOpen: false,
  error: false,
}

const businessReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.FETCHINDUSTRYCATEGORIES:
      state = {
        ...state,
        industryCategories: payload,
      }
      break
    case actionTypes.TOGGLEBUSINESSDETAILS:
      state = {
        ...state,
        businessDialogOpen: payload,
      }
      break
    case actionTypes.TOGGLESEARCHERROR:
      state = {
        ...state,
        error: payload,
      }
      break
    case actionTypes.UPDATESEARCHCRITERIA:
      state = {
        ...state,
        searchCriteria: payload,
      }
      break
    case actionTypes.FETCHCOMPANY:
      state = {
        ...state,
        searchList: payload,
      }
      break
    case actionTypes.LOADSPINNER:
      state = {
        ...state,
        showSpinner: payload,
      }
      break
    case actionTypes.CLEARSEARCH:
      state = {
        ...initialState,
        monitoredCompanies: state.monitoredCompanies,
      }
      break
    case actionTypes.UPDATESELECTEDBUSINESS:
      state = {
        ...state,
        selectedBusiness: payload,
      }
      break
    case actionTypes.FETCHBUSINESSCOUNT:
      state = {
        ...state,
        businessCount: payload,
      }
      break
    case actionTypes.FETCHBMONITEREDCOMPANIES:
      state = {
        ...state,
        monitoredCompanies: payload,
        monitorCompaniesLoaded: true,
      }
      break
    case actionTypes.LOADINGMONITOREDCOMPANIES:
      state = {...state, monitorCompaniesLoaded: false}
      break
    case actionTypes.LOADINGCLAIMEDBUSINESSES:
      state = {...state, claimedBusinessesLoaded: false}
      break
    case actionTypes.HANDLEBUSINESSNAKBAR:
      state = {
        ...state,
        snakBarData: payload,
      }
      break
    case actionTypes.FETCHCLAIMEDBUSINESS:
      if (state.selectedBusiness !== null) {
        const updatedBusiness = payload.claimedBusinesses?.find(
          business => state.selectedBusiness && state.selectedBusiness.ext_id === business.ext_id,
        )
        if (updatedBusiness) {
          state = {
            ...state,
            claimedBusinesses: payload.claimedBusinesses || [],
            claimedBusinessesLoaded: true,
            selectedBusiness: updatedBusiness,
          }
        }
      }

      state = {
        ...state,
        claimedBusinesses: payload.claimedBusinesses || [],
        claimedBusinessesLoaded: true,
      }
      break
    default:
      return state
  }
  return state
}

export default businessReducer
